import { render, staticRenderFns } from "./ImWebimCustomer.vue?vue&type=template&id=c9d3ff0c&scoped=true&"
import script from "./ImWebimCustomer.vue?vue&type=script&lang=js&"
export * from "./ImWebimCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ImWebimCustomer.vue?vue&type=style&index=0&id=c9d3ff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d3ff0c",
  null
  
)

export default component.exports